import {gmAPI, MapService, Markers} from '@/services/MapService';
import {Graphics} from '@/services/GraphicService';
import {blue} from '@/lib/colors';

let eventListener; // The Map event listener for drawing.
const drawings = [];
let strokeColor = blue;
let strokeWeight = 10;

function startDrawing() {
  const map = MapService.getMap();
  // Set cursor to pencil and modify map controls to allow for drawing
  map.setOptions({
    zoomControl: true,
    scrollWheel: true,
  });
  MapService.setCursor('pencil');
  Markers.setAllClickable(false);
  Graphics.setAllClickable(false);
  // Set up the click event listener.
  eventListener = gmAPI.event.addListener(map, 'mousedown', handleEventFreeDraw);
}

function stopDrawing() {
  MapService.setCursor(null);
  Markers.setAllClickable(true);
  Graphics.setAllClickable(true);
  eventListener?.remove();
}

function clearDrawings() {
  while (drawings.length) {
    drawings.pop().setMap(null);
  }
}

function undoLine() {
  if (drawings.length) {
    drawings.pop().setMap(null);
  }
}

const validEvent = (e) => {
  if (['mouseup', 'mousedown'].includes(e.domEvent.type) && e.domEvent.button !== 0) return false;
  if (e.domEvent.type === 'touchstart' && e.domEvent.touches.length > 1) return false;
  return true;
};

function handleEventFreeDraw(e) {
  if (!validEvent(e)) return;
  const map = MapService.getMap();

  // Determine straight-line mode if modifier held at mousedown (Shift)
  const isStraight = e.domEvent && e.domEvent.shiftKey;

  map.setOptions({
    gestureHandling: 'none',
  });

  // Start path. For straight mode initialize with two identical points so we can update the 2nd point.
  const initialPath = isStraight ? [e.latLng, e.latLng] : [e.latLng];

  const poly =
      new gmAPI.Polyline({
        map,
        clickable: false,
        strokeColor,
        strokeOpacity: 1.0,
        strokeWeight,
        path: initialPath,
      });

  // Listener to extend the line as the mouse is moved.
  const mousemoveListener = gmAPI.event.addListener(map, 'mousemove', (ev) => {
    if (isStraight) {
      // keep only two points: start and current
      const path = poly.getPath();
      path.setAt(1, ev.latLng);
    } else {
      poly.getPath().push(ev.latLng);
    }
  });

  // Listener to commit the poly to store and stop drawing once left mouse button is released.
  const mouseupListener = gmAPI.event.addListener(map, 'mouseup', (ev) => {
    if (!validEvent(ev)) return;
    // On mouseup, set the default map controls and add this polyline to the array of drawings in state
    map.setOptions({
      gestureHandling: 'greedy',
    });
    addDrawing(poly);
    // Remove the drawing listeners now that user is no longer dragging.
    mousemoveListener.remove();
    mouseupListener.remove();
  });
}

function addDrawing(drawing) {
  drawings.push(drawing);
}

function setColor(color) {
  strokeColor = color;
}

function getColor() {
  return strokeColor;
}

function setWeight(weight) {
  strokeWeight = weight;
}

export {
  startDrawing,
  stopDrawing,
  clearDrawings,
  undoLine,
  setColor,
  getColor,
  setWeight,
};
